import(/* webpackMode: "eager" */ "/vercel/path0/src/app/sourcing-guide/page.tsx");
